// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"deffc097","845":"42f3103e"}[chunkId] + ".chunk.js";
};